import { BrowseViewResponseDto, ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { Classification } from '@/common';

export const getClassifications = async ({
  page,
  pageSize,
  search,
  productId,
  standard,
}: {
  page: number;
  pageSize: number;
  search: string;
  productId?: string;
  standard?: string;
}): Promise<BrowseViewResponseDto<Classification>> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/classifications?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
      productId: productId || '',
      standard: standard || '',
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<Classification>;
  return response;
};
